export type S3UploaderTypesEnum = 'venue' | 'event' | 'legal';

export const S3UploaderTypes = {
  Venue: 'venue' as S3UploaderTypesEnum,
  Event: 'event' as S3UploaderTypesEnum,
  Legal: 'legal' as S3UploaderTypesEnum
}

export type S3UploaderRatioEnum = '16x9' | '4x3' | '1x1' | 'logo' | 'email';

export const S3UploaderRatios = {
  Modern: '16x9' as S3UploaderRatioEnum,
  Retro: '4x3' as S3UploaderRatioEnum,
  Square: '1x1' as S3UploaderRatioEnum,
  Logo: 'logo' as S3UploaderRatioEnum,
  Email: 'email' as S3UploaderRatioEnum
}

export interface S3ImageBlob {
  [key: string]: Blob
}
